import { useContext, useEffect, useState } from "react";
import { useRedirect } from "react-admin";
import { AppContext } from "../../../../providers/app-context-provider/app.context";
import authProvider from "../../../../providers/auth-provider";
import { useFederatedParams } from "./useFederatedParams";

export default function useFederatedLogin() {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [context, setContext] = useState(null)
    const { token, institution } = useFederatedParams()

    const appContext = useContext(AppContext)

    const redirect = useRedirect()

    useEffect(() => {

        const authenticate = async () => {

            try {

                if (!token || !institution) throw new Error('Parâmetros inválidos.');
                const response = await authProvider.ssoFetchToken(institution, token);
                const ssoToken = response.data.ssoToken;
                await authProvider.ssoAuthenticate(ssoToken).then(
                    res => {
                        appContext.setContext(res)
                    }
                );

                redirect('/')
            } catch (e) {
                setError(e.response?.data?.message ?? e.message ?? 'Erro ao autenticar.');
            } finally {
                setLoading(false);
            }
        }
        authenticate();
    }, []);

    return { loading, error, context };
}